import angular from 'angular';

const INSPECTOR_ROLE_TO_DOCUMENT_TYPE_MAPPING = {
  'foundation':'inspection_report_foundation',
  'hvac':'inspection_report_hvac',
  'inspector':'inspection_report_general',
  'other':'inspection_report_other',
  'pool':'inspection_report_pool',
  'roof':'inspection_report_roof',
  'termite':'inspection_report_termite',
  'plumbing': 'inspection_report_plumbing',
  'electrical': 'inspection_report_electrical',
};

module.exports = angular.module('common.services.inspector_role_to_document_type', [])
.service('InspectorRoleToDocumentType', class {
  getDocumentTypeForInspectionReport(inspectionReport) {
    return INSPECTOR_ROLE_TO_DOCUMENT_TYPE_MAPPING[inspectionReport.role] || 'misc';
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/inspector_role_to_document_type.js
 **/